import { render, staticRenderFns } from "./LoginRequired.vue?vue&type=template&id=4f85f4a7&"
import script from "./LoginRequired.vue?vue&type=script&lang=ts&"
export * from "./LoginRequired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports